// extracted by mini-css-extract-plugin
export var audioPlayer = "_qa-0";